import React from 'react';
import styled from 'styled-components';

import StartDatePresetPicker from './components/StartDatePresetPicker';
import DurationPicker from './components/DurationPicker';

import type { IVacationOptionsPicker } from './types';

import {
  convertCalendarDatesToNightsInterval,
  convertCalendarDateToPreset,
} from '../../../../utils';

export const VacationOptionsPicker = (props: IVacationOptionsPicker): JSX.Element => {
  const {
    isMobile,
    isHotelOnly,
    selectedStartDatePreset,
    customStartDatePreset,
    selectStartDatePreset,
    startDateCell,
    endDateCell,
    selectedDurationPickerMode,
    toggleDurationPickerMode,
    vacationOptionsPresets: { startDatePresets, nightsPresets },
    nights,
    nightsPreset,
    selectDuration,
    handleNightsButtonClick,
  } = props;

  const calendarStartDatePreset = convertCalendarDateToPreset(startDateCell);
  const calendarNightsInterval = convertCalendarDatesToNightsInterval({
    startDateCell,
    endDateCell,
  });

  const isStartDateSelected = !!(startDateCell.date || selectedStartDatePreset);

  return (
    <Container $isMobile={isMobile}>
      <StartDatePresetPicker
        isMobile={isMobile}
        startDatePresets={startDatePresets}
        customStartDatePreset={customStartDatePreset}
        calendarStartDatePreset={calendarStartDatePreset}
        selectedStartDatePreset={selectedStartDatePreset}
        selectStartDatePreset={selectStartDatePreset}
      />
      <DurationPicker
        isMobile={isMobile}
        isHotelOnly={isHotelOnly}
        selectedMode={selectedDurationPickerMode}
        toggleMode={toggleDurationPickerMode}
        nightsPresets={nightsPresets}
        isStartDateSelected={isStartDateSelected}
        nights={nights || calendarNightsInterval}
        nightsPreset={nightsPreset}
        selectDuration={selectDuration}
        handleNightsButtonClick={handleNightsButtonClick}
      />
    </Container>
  );
};

const Container = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;

  width: 100%;

  margin-bottom: 24px;

  ${({ $isMobile }) =>
    $isMobile &&
    `
      width: 100%;
      height: 100%;
      padding-left: 4px;
  `}
`;
